/* eslint-disable no-control-regex */
export const TABLET_SIZE = 769;
export const CLOSE_SIDEBAR_SIZE = TABLET_SIZE + 200;
